/**
 * Base path for the application when deployed behind a reverse proxy.
 * All routes and assets will be served under this path.
 *
 * IMPORTANT: If you change this value, also update:
 * - src/styles.css (font-face url)
 */
export const BASE_PATH = '/next';
export const CORE_API_CLIENT_ID = 'website-next';
export const REDIS_TIMEOUT = 10_000;

export const NETWORK_REFERRAL_REWARD = 20;
export const NETWORK_REFERRAL_MINIMUM_INCENTIVE = 75;
export const PROJECT_REFERRAL_REWARD = 50;
export const PROJECT_REFERRAL_MINIMUM_INCENTIVE = 100;

export const RECAPTCHA_SCORE_THRESHOLD = 0.7;
export const RECAPTCHA_VERIFY_URL =
  'https://www.google.com/recaptcha/api/siteverify';

export const RECAPTCHA_ENABLED_ENVIRONMENTS: Set<string> = new Set([
  'production',
]);

/**
 * Hosts a reCAPTCHA token may have been solved on. Google reports the page's
 * hostname with every verification, so a token minted on any other site that
 * carries our site key is refused. Production serves every captcha-protected
 * page (`/next/*`) from app.respondent.io only; www.app.respondent.io goes to
 * the legacy site, and the marketing site links here rather than embedding the
 * forms. Add a host here before enabling reCAPTCHA in another environment.
 */
export const RECAPTCHA_ALLOWED_HOSTNAMES: ReadonlySet<string> = new Set([
  'app.respondent.io',
]);
